import { Component, OnInit } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as ptLocale from 'date-fns/locale/pt';
import locale from 'date-fns/locale/pt';
import swal from 'sweetalert2';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-swith-range-date-result',
  templateUrl: './swith-range-date-result.component.html',
  styleUrls: ['./swith-range-date-result.component.scss']
})
export class SwithRangeDateResultComponent extends ComponentBase implements OnInit {

  valueChange: boolean = false;
  term: AttributeModel;
  start: AttributeModel;
  end: AttributeModel;
  duration: AttributeModel;
  note: AttributeModel;
  isLoadValueChange: boolean = false;

  date: Date;
  optStat: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: 'dd/MM/yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale,
    minDate: new Date(Date.now()), // Minimal selectable date
    // maxDate: new Date(Date.now()),  // Maximal selectable date
    // barTitleIfEmpty: '',
    placeholder: '', // HTML input placeholder attribute (default: '')
    // inputClass: 'form-control m-input', // Optional, value to pass on to [ngClass] on the input field
  };

  optEnd: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: 'dd/MM/yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale,
    minDate: new Date(Date.now()), // Minimal selectable date
    // maxDate: new Date(Date.now()),  // Maximal selectable date
    // barTitleIfEmpty: '',
    placeholder: '', // HTML input placeholder attribute (default: '')
    // inputClass: 'form-control m-input', // Optional, value to pass on to [ngClass] on the input field
  };

  constructor() { super() }

  ngOnInit() {
    let datePickers = this.attribute.attributes
      .filter(a => a.type.toLowerCase() == "datepicker")

    if(datePickers.length > 0) {
      this.start = datePickers[0]
    }

    if(datePickers.length > 1) {
      this.end = datePickers[1]
    }

    this.term = this.attribute.attributes
      .find(a => a.type.toLowerCase() == "boolean")

    this.duration = this.attribute.attributes
      .find(a => a.type.toLowerCase() == "text")

    this.ngCalculeDay(this.start.value, this.end.value);

  }

  getTermValue(): string {
    return this.term == null ? "false" : this.term.value
  }

  getTermKey(): string {
    return this.term == null ? "" : this.term.key
  }

  hasSwitch(): boolean {
    return this.term != null
  }

  VisiblevalueChange(){
    let swichVisible = this.getOptionByKey(this.term, 'view');
    
    if (swichVisible == 'hide' || this.term.value != 'true'){
      return true;
    }
    else{
      return false;
    }
    
  }

  ngBlurInput(id: string, attribute: AttributeModel) {
 
    if(id.length == 0) {
      return
    }
    
    if (!this.attribute.value)
      $('#' + id).removeClass('has-error');
  }

  ngChecked(value: string): boolean {

    if (value == 'true')
      return true;
    else
      return false;
    // console.log(this.term.value == '' ? false : this.term.value == 'true' ? true : false);
    // return this.term.value == '' ? false : this.term.value == 'true' ? true : false;
  }


  onChangeDuration() {
    this.duration.value = this.ngCalculeDay(this.start.value, this.end.value);
  }

  ngCalculeDay(start: any, end: any): string {
    if ((start != null && start != '') && (end != null && end != '')) {
      if (start.getTime() <= end.getTime()) {
        var diff = Math.abs(start.getTime() - end.getTime());
        var duration = Math.ceil(diff / (1000 * 3600 * 24));
        return duration.toString();
      }
      else {

        swal.fire('Atenção!', 'A data inícial não pode ser maior que a de término.', 'info');
        this.valueChange = true;
       
        setTimeout(() => { this.valueChange = false; }, 1000);
      }
    }
  }

  onValueChange(value: boolean) {

    this.valueChange = value;
    if (value) {
      this.start.value = '';
      this.end.value = '';
      this.duration.value = '';
      $('#endDate').val('');
      $('#startDate').val('');
      this.term.value = 'true';
    }
    else {
      this.term.value = 'false';
    }
  }
}
